import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '../config/translations';

Vue.use(VueI18n);

export const SUPPORTED_LANGUAGES = ['fi', 'en'];
const LANG_STORAGE_KEY = 'tassu-lang';

function storeLanguage(lang) {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch (e) {
    // localStorage not available (e.g. blocked in iframe)
  }
}

// Language priority: ?lang= in URL, then remembered choice, then Finnish
function resolveInitialLanguage() {
  // Hash router puts the query after '#' (e.g. /#/?lang=en), so check both
  const hashQuery = window.location.hash.split('?')[1] || '';
  const urlLang = (new URLSearchParams(window.location.search).get('lang')
    || new URLSearchParams(hashQuery).get('lang') || '').toLowerCase();
  if (SUPPORTED_LANGUAGES.includes(urlLang)) {
    storeLanguage(urlLang);
    return urlLang;
  }
  try {
    const storedLang = localStorage.getItem(LANG_STORAGE_KEY);
    if (SUPPORTED_LANGUAGES.includes(storedLang)) {
      return storedLang;
    }
  } catch (e) {
    // localStorage not available
  }
  return 'fi';
}

const initialLanguage = resolveInitialLanguage();
document.documentElement.lang = initialLanguage;

// Initialize the localization library
const i18n = new VueI18n({
  locale: initialLanguage,
  fallbackLocale: 'fi',
  messages,
});

export function setLanguage(lang) {
  i18n.locale = lang;
  document.documentElement.lang = lang;
  storeLanguage(lang);
}

export default i18n;
